import React, { Component } from "react";
import {
  AppProvider,
  Frame,
} from "@shopify/polaris";
import './index.css'
import Router from '../Router';
// 多语言
import cs from "@shopify/polaris/locales/cs.json";
import da from "@shopify/polaris/locales/da.json";
import de from "@shopify/polaris/locales/de.json";
import en from "@shopify/polaris/locales/en.json";
import es from "@shopify/polaris/locales/es.json";
import fr from "@shopify/polaris/locales/fr.json";
import it from "@shopify/polaris/locales/it.json";
import nl from "@shopify/polaris/locales/nl.json";
import nb from "@shopify/polaris/locales/nb.json";
import pl from "@shopify/polaris/locales/pl.json";
import pt_BR from "@shopify/polaris/locales/pt-BR.json";
import pt from "@shopify/polaris/locales/pt-PT.json";
import fi from "@shopify/polaris/locales/fi.json";
import sv from "@shopify/polaris/locales/sv.json";
import tr from "@shopify/polaris/locales/tr.json";
import th from "@shopify/polaris/locales/th.json";
import ja from "@shopify/polaris/locales/ja.json";
import zh_hant from "@shopify/polaris/locales/zh-TW.json";
import zh from "@shopify/polaris/locales/zh-CN.json";
import ko from "@shopify/polaris/locales/ko.json";

import NavigationRoute from './Admin/NavigationRoute'
import TopNavBar from './Admin/TopNavBar'
import GiftBlock from './Admin/GiftBlock'
import { store } from '../redux/store';
import i18n from 'i18next';
import debounce from 'lodash-es/debounce';
import { changeLanguageInfo, setLangState, setShopifyLang } from "../redux/actions/getAppPublicData";
import TabsPublicBlock from "../components/TabsPublicBlock";

class indexClass extends Component {
  state = {
    language: 'en',
    langJson: en,
  }

  UNSAFE_componentWillMount() {
    const params = new URLSearchParams(window.location.search);
    const locales = params.get("locale");
    // 判断+翻译shopify首选语言
    const ShopifyLangList = {
      "cs": "cs",
      "da": "da",
      "de": "ge",
      "en": "en",
      "es": "sp",
      "fr": "fr",
      "it": "it",
      "in": "in",
      "nl": "dut",
      "nb": "nb",
      "pl": "pl",
      "pt-BR": "pt_BR",
      "pt-PT": "pt",
      "fi": "fi",
      "sv": "sv",
      "tr": "tr",
      "th": "th",
      "ja": "ja",
      "zh-CN": "zh",
      "zh-TW": "zh_hant",
      "ko": "ko",
    }
    this.transShopifyLang(ShopifyLangList[locales]);
  }

  // 翻译shopify语言
  transShopifyLang = (val) => {
    const lang = val || 'en';
    i18n.changeLanguage(lang);          // 缓存语言
    store.dispatch(setLangState(true)); // 更新设置状态
    store.dispatch(setShopifyLang(lang));
    store.dispatch(changeLanguageInfo(lang));
    this.handleChangeShopifyi18n(lang);
  }

  componentDidMount() {
    // 根据id显隐 顶部和导航栏
    store.subscribe(debounce(() => {
      const isShopiy = window.shopify;
      const sData = store.getState().public;
      if (!isShopiy) {
        if (!sData.isShowTopMenu) {
          this.hideTopAndNav(true);
        } else {
          this.hideTopAndNav(false);
        }
      }
      // 更新ui语言
      if (Boolean(sData.Language) && Boolean(sData.Language !== this.state.language) && !Boolean(sData.appLangState)) {
        let lang = sData.Language || 'en';
        i18n.changeLanguage(lang);          // 缓存语言
        store.dispatch(setLangState(true)); // 更新设置状态
        this.handleChangeShopifyi18n(lang);
      }
    }, 50));
  }

  // 隐藏TopMenu+侧边
  hideTopAndNav = (_hide = false) => {
    const display = _hide ? 'none' : '';
    const padding = _hide ? '0' : '3.5rem';
    document.getElementById('AppFrameTopBar')?.style?.setProperty('display', display);
    document.getElementById('NavigationMenu')?.style?.setProperty('display', display);
    document.getElementById('AppFrameMain')?.style?.setProperty('padding-top', padding);
  }

  // 切换shopify内置语言
  handleChangeShopifyi18n = (lang = 'en') => {
    const langList = {
      "cs": cs,
      "da": da,
      "ge": de,
      "en": en,
      "sp": es,
      "fr": fr,
      "it": it,
      "in": en,
      "dut": nl,
      "nb": nb,
      "pl": pl,
      "pt_BR": pt_BR,
      "pt": pt,
      "fi": fi,
      "sv": sv,
      "tr": tr,
      "th": th,
      "ja": ja,
      "zh_hant": zh_hant,
      "zh": zh,
      "ko": ko,
    }
    let langeData = langList[lang];
    this.setState({
      language: lang,
      langJson: langeData,
    })
  }

  // 伸缩导航栏
  toggleNavMenus = (states = false) => {
    this.$navChild.toggleNavMenusAction(states);
    this.$navChild.closeNavBlock(states);
  }

  // 菜单组件事件
  toggleNavAction = (action) => {
    window.navChildAction = action;
    this.$navChild = action;
  }

  toggleMobileNavigationActive = () => {
    this.setMobileNavigationActive(false);
  }

  setMobileNavigationActive = (data) => {
    this.setState({
      mobileNavigationActive: data,
    });
  }

  changeMobileNavStatus = (data) => {
    this.setState({
      mobileNavigationActive: data,
    });
  }

  // 顶部bar内部事件
  handleTopNavAction = (action) => {
    this.$topBarAction = action;
    window.topBarAction = action;
  }

  render() {
    const {
      langJson,
    } = this.state;

    const isShopify = window.shopify;

    return (
      <div className="SEOMaster">
        <AppProvider i18n={langJson}>
          <Frame
            //头部
            topBar={
              !isShopify && <TopNavBar toggleNavMenus={this.toggleNavMenus} handleTopNavAction={this.handleTopNavAction} changeMobileNavStatus={this.changeMobileNavStatus} />
            }
          >
            <div className="SEOAnt-main">
              {/* 导航栏 */}
              {!isShopify && <NavigationRoute toggleNavAction={this.toggleNavAction} />}
              {/* 倒计时组件 */}
              <GiftBlock />

              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div id="TabsPublic">
                  <TabsPublicBlock />
                </div>

                {/* 路由组件 */}
                <Router />
              </div>
            </div>
          </Frame>
        </AppProvider>
      </div>
    );
  }
}

export default indexClass;